import React, { useEffect } from "react";
import { useForm, useFormState } from "react-final-form";
import { useExitIntentSettingsModal } from "../../utils/useExitIntentSettingsModal";
import { ExitIntentFormFields } from "../ExitIntentFormFields/ExitIntentFormFields";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import ExlyLoader from "ui/modules/ExlyLoader";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";

export const ExitIntentSettingsModal = withComponentLibraryTheme(
  ({ handleSubmit = () => {} }) => {
    const {
      isExitIntentSettingsModalOpen,
      closeExitIntentSettingsModal: closeModal,
      fetchExitIntentSettings,
      exitIntentInitialValuesLoading,
    } = useExitIntentSettingsModal();

    const formState = useFormState();
    const form = useForm();
    const isDirty = formState.dirty;

    const closeExitIntentSettingsModal = () => {
      form.reset();
      closeModal();
    };

    useEffect(() => {
      if (isExitIntentSettingsModalOpen) fetchExitIntentSettings();
    }, [isExitIntentSettingsModalOpen]);
    return (
      <ExlyModal
        title="Settings"
        header="Settings"
        primaryBtnText="Save changes"
        onPrimaryBtnClick={handleSubmit}
        primaryBtnProps={{ disabled: !isDirty }}
        open={isExitIntentSettingsModalOpen}
        onClose={closeExitIntentSettingsModal}
        padded={false}
        showSecondaryBtn={true}
        modal_props={{
          modalPaperClassName: "tw-w-[440px]",
          secondaryBtnClassName: "tw-text-[#493ab1] tw-min-w-0",
          footerClassName: "tw-justify-between",
        }}
        mobile_modal_props={{
          secondaryAction: {
            label: "Cancel",
            onClick: closeExitIntentSettingsModal,
            className: "tw-text-[#493ab1] tw-min-w-0",
          },
        }}
      >
        <div className="tw-flex tw-flex-col tw-px-5 tw-py-4">
          {exitIntentInitialValuesLoading ? (
            <ExlyLoader showText={false} className="tw-h-[150px]" />
          ) : (
            <ExitIntentFormFields />
          )}
        </div>
      </ExlyModal>
    );
  }
);
